<template>
  <div class="relative bg-primary-800">
    <div class="relative lg:z-10 pb-4 pt-14 lg:py-40">
      <TContainer>
        <TGrid>
          <div class="col-span-12 text-center flex items-center justify-center">
            <TTitle
              class="w-full"
              color="text-white"
              tag="h1"
              size="5xl"
              :bold="true"
              :critical="true"
            >
              {{ title }}
            </TTitle>
          </div>
        </TGrid>
      </TContainer>
    </div>

    <div
      v-if="image"
      class="relative lg:absolute lg:z-0 inset-0 aspect-w-3 aspect-h-2 lg:aspect-none"
    >
      <div>
        <TLazyimg :src="image" alt="" />
      </div>
      <div>
        <div
          class="hidden lg:block absolute inset-0 w-full h-full bg-primary-900/40 mix-blend-multiply"
        />
      </div>

      <div v-if="badge">
        <TContainer class="absolute bottom-0 right-0">
          <div class="text-center pb-4 lg:pb-8">
            <UBadge data-test="badge" color="neutral" size="xs">
              {{ badge }}
            </UBadge>
          </div>
        </TContainer>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface propsInterface {
  image: string
  title: string
  badge: string | null
}

defineProps<propsInterface>()
</script>
